var a = [
  "structure",
  "horizontalSurface",
  "accent1",
  "verticalSurface",
  "accent2",
  "lightSubtle",
  "darkSubtle"
], t = [
  "src",
  "color",
  "roughness",
  "metallic"
];
function c(r, e) {
  return `${r}${e.charAt(0).toUpperCase()}${e.slice(1)}`;
}
var l = {
  structure: "structure",
  horizontalsurface: "horizontalSurface",
  accent01: "accent1",
  verticalsurface: "verticalSurface",
  accent02: "accent2",
  lightsubtle: "lightSubtle",
  darksubtle: "darkSubtle",
  material01: "structure",
  base1: "structure",
  material02: "horizontalSurface",
  base2: "horizontalSurface",
  material03: "accent1",
  base3: "accent1",
  material04: "verticalSurface",
  base4: "verticalSurface",
  material05: "accent2",
  base5: "accent2",
  material06: "lightSubtle",
  base6: "lightSubtle"
};
function o(r) {
  return r.trim().replace(/\.\d+$/, "").replace(/[\s_-]+/g, "").toLowerCase();
}
function A(r) {
  if (!r) return null;
  const e = o(r);
  return Object.hasOwn(l, e) ? l[e] : null;
}
function y(r) {
  const e = a.length;
  return a[(r % e + e) % e];
}
var p = new Map(a.flatMap((r) => t.map((e) => [c(r, e), r])));
function O(r) {
  return p.get(r) ?? null;
}
var s = [
  "background",
  "panel",
  "card",
  "muted",
  "primary",
  "secondary",
  "accent",
  "success",
  "warning",
  "error",
  "info"
], i = [
  "color",
  "textColor",
  "finish"
], f = [
  "matte",
  "satin",
  "gloss"
];
function h(r, e) {
  return `${r}${e.charAt(0).toUpperCase()}${e.slice(1)}`;
}
var m = "borderColor", n = {
  fillbg: "panel",
  framebg: "background"
};
function F(r) {
  if (!r) return null;
  const e = o(r);
  return Object.hasOwn(n, e) ? n[e] : null;
}
var u = [
  "title",
  "header",
  "body",
  "mono"
], S = [
  "font",
  "weight",
  "scale",
  "lineHeight"
], R = {
  title: {
    scale: 1.5,
    lineHeight: 1.25
  },
  header: {
    scale: 1.25,
    lineHeight: 1.4
  },
  body: {
    scale: 1,
    lineHeight: 1.4
  },
  mono: {
    scale: 1,
    lineHeight: 1.4
  }
};
function b(r, e) {
  return `${r}${e.charAt(0).toUpperCase()}${e.slice(1)}`;
}
var _ = {
  src: {
    type: "string",
    kind: "material"
  },
  color: { type: "color" },
  roughness: { type: "number" },
  metallic: { type: "number" }
}, g = {
  color: { type: "color" },
  textColor: { type: "color" },
  finish: { type: "string" }
}, v = {
  font: { type: "string" },
  weight: { type: "number" },
  scale: { type: "number" },
  lineHeight: { type: "number" }
}, E = new Map([
  ...a.flatMap((r) => t.map((e) => [c(r, e), _[e]])),
  ...s.flatMap((r) => i.map((e) => [h(r, e), g[e]])),
  [m, { type: "color" }],
  ...u.flatMap((r) => S.map((e) => [b(r, e), v[e]]))
]);
function T(r) {
  return E.has(r);
}
var d = !1, C = 1;
function L() {
  return {
    version: 1,
    materialRoles: [...a],
    materialSuffixes: [...t],
    surfaceRoles: [...s],
    surfaceSuffixes: [...i],
    surfaceFinishes: [...f],
    textRoles: [...u],
    textSuffixes: [...S],
    textScaleLadder: R,
    properties: Object.fromEntries([...E].map(([r, e]) => [r, {
      ...e,
      inherits: !1
    }]))
  };
}
export {
  c as S,
  t as _,
  u as a,
  y as b,
  d as c,
  T as d,
  F as f,
  a as g,
  L as h,
  i,
  E as l,
  b as m,
  f as n,
  R as o,
  h as p,
  s as r,
  S as s,
  m as t,
  C as u,
  o as v,
  O as x,
  A as y
};

//# sourceMappingURL=theme-vocabulary-CiKlp9h0.js.map